// Firebase v9+ (modular)
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getMessaging } from "firebase/messaging";
import { getStorage } from "firebase/storage";

// Configuration Firebase
const firebaseConfig = {
  apiKey: "AIzaSyBgLj79u1bk2EBT7Ec9Twwd8sUFWrdFfhg",
  authDomain: "bamboosushi-albi-vue.firebaseapp.com",
  projectId: "bamboosushi-albi-vue",
  storageBucket: "bamboosushi-albi-vue.firebasestorage.app",
  messagingSenderId: "700205490097",
  appId: "1:700205490097:web:f3c76bc14683aaaba86790"
};

// Initialisation
const app = initializeApp(firebaseConfig);

// Firestore
const db = getFirestore(app);

// Auth
const auth = getAuth(app);

// Messaging
const messaging = getMessaging(app);

// Storage (photos produits)
const storage = getStorage(app);

export { app, db, auth, messaging, storage };
